import request from "./request";

//模板
export const getAdCount = (data) => request("/kuaishou/getAdvertiserList", data, "POST");
export const getAdertiserProduct = (data) => request("/kuaishou/getProducts", data, "POST");
export const queryTemplate = (data) => request("/toutiao/queryTemplate", data, "GET");

// //广告计划
export const getCampaignList = (data) => request("/kuaishou/getCampaignList", data, "POST");
// export const updateCampaign = (data) => request("/toutiao/updateCampaign", data, "POST");

//快手应用
export const kuaishouAppList = (data) => request("/kuaishou/convert", data, "GET");

//基础设置
export const creativeWord = (data) => request("/kuaishou/creativeWord", data, "GET");
export const actionBar = (data) => request("/kuaishou/actionBar", data, "GET");
// export const queryConvert = (data) => request("/toutiao/queryConvert", data, "POST");
// export const getCrowdTag = (data) => request("/toutiao/getCrowdTag", data, "GET");

// export const getPromotion = (data) => request("/toutiao/getPromotion", data, "GET");
// export const getCallToAction = (data) => request("/toutiao/getCallToAction", data, "GET");
// export const playableList = (data) => request("/toutiao/playableList", data, "GET");

export const queryCreativeCategory = (data) => request("/kuaishou/queryCreativeCategory", data, "GET");
export const saveCreativeLable = (data) => request("/toutiao/saveCreativeLable", data, "POST_JSON");
export const queryCreativeLable = (data) => request("/toutiao/queryCreativeLable", data, "GET");

// export const getSitePage = () => request("/toutiao/getSitePage", null, "GET");


//定向包
export const audience = (data) => request("/kuaishou/audience", data, "GET");
export const getPackParams = (data) => request("/toutiao/getPackParams", data, "GET");
export const behavioAndInterest = (data) => request("/kuaishou/behavioAndInterest", data, "GET");
export const targetTag = (data) => request("/kuaishou/targetTag", data, "GET");
export const appSearch = (data) => request("/kuaishou/appSearch", data, "GET");
export const newPack = (data) => request("/kuaishou/saveTargetPack", data, "POST_JSON");
export const getPack = (data) => request("/kuaishou/queryTargetPack", data, "GET");
// export const flowPackage = (data) => request("/toutiao/flowPackage", data, "GET");

// //预算与出价
export const newBudget = (data) => request("/toutiao/newBudget", data, "POST_JSON");
export const getBudget = (data) => request("/toutiao/getBudget", data, "GET");

// //创意组
export const getKuaishouId = (data) => request("/fileMgt/getKuaishouId", data, "GET");
// export const getFolders = () => request("/fileMgt/getFolders", null, "GET");
// export const getTag = () => request("/tag/getTag", null, "GET");
// export const getDesigner = () => request("/tag/getDesigner", null, "GET");
// export const getFiles = (data) => request("/fileMgt/getFiles", data, "GET");
export const saveCreativeGroup = (data) => request("/toutiao/saveCreativeGroup", data, "POST");
export const queryCreativeGroup = () => request("/toutiao/queryCreativeGroup", null, "GET");

//落地页
export const webUrl = (data) => request("/kuaishou/webUrl", data, "GET");

// //创意标题
export const getCreativeWord = () => request("/toutiao/getCreativeWord", null, "GET");
export const saveCreativeTitle = (data) => request("/toutiao/saveCreativeTitle", data, "POST");
export const queryCreativeTitle = () => request("/toutiao/queryCreativeTitle", null, "GET");

// //提交预览
export const preview = (data) => request("/kuaishou/preview", data, "POST_JSON");
export const createTemplate = (data) => request("/toutiao/createTemplate", data, "POST");
export const publish = (data) => request("/kuaishou/publish", data, "GET");